"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 0.5rem;\n  position: relative;\n  display: block;\n  border-radius: 2rem;\n  overflow: hidden;\n  ", " {\n    height: 100%;\n    left: 0;\n    top: 0;\n    border-radius: 0 2rem 2rem 0;\n    width: ", "%;\n    position: absolute;\n  }\n  ", "\n  /* negative increment */\n", "\n", "\n", "\n", "\n\n/* type positive */\n\n", "\n", "\n", "\n", "\n\n/* type neutral */\n\n", "\n\n/* type neutral */\n\n", "\n\n\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ProgressStyled = (0, _styledComponents["default"])(_Box["default"])(_templateObject(), _Box["default"], function (props) {
  return props.progress;
}, function (props) {
  return props.small && 'height: .25rem;';
}, function (props) {
  return props.type === 'negative' && props.progress <= '25' && "".concat(_Box["default"], "{background: ").concat(props.theme.colors.palette.greens[3], ";} ");
}, function (props) {
  return props.type === 'negative' && props.progress >= '26' && props.progress <= '50' && " ".concat(_Box["default"], "{background: ").concat(props.theme.colors.palette.grays[5], ";}");
}, function (props) {
  return props.type === 'negative' && props.progress >= '51' && props.progress <= '75' && " ".concat(_Box["default"], " {background: ").concat(props.theme.colors.warning, ";}");
}, function (props) {
  return props.type === 'negative' && props.progress >= '76' && " ".concat(_Box["default"], " {background: ").concat(props.theme.colors.danger, ";}");
}, function (props) {
  return props.type === 'positive' && props.progress > '90' && "\n\n".concat(_Box["default"], "{background: ").concat(props.theme.colors.palette.greens[3], ";}\n");
}, function (props) {
  return props.type === 'positive' && props.progress >= '70' && props.progress <= '90' && "\n\n".concat(_Box["default"], "{background: ").concat(props.theme.colors.palette.grays[5], ";}\n");
}, function (props) {
  return props.type === 'positive' && props.progress >= '50' && props.progress <= '69' && "\n".concat(_Box["default"], "{background: ").concat(props.theme.colors.warning, ";}\n");
}, function (props) {
  return props.type === 'positive' && props.progress < '50' && "\n\n".concat(_Box["default"], "{background: ").concat(props.theme.colors.danger, ";}\n");
}, function (props) {
  return props.type === 'neutral' && "\n".concat(_Box["default"], "{background: ").concat(props.theme.colors.palette.neutrals[3], ";}\n");
}, function (props) {
  return props.type === 'custom' && "\n\n";
});

var Progress = function Progress(props) {
  return /*#__PURE__*/_react["default"].createElement(ProgressStyled, props, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    bg: props.color
  }));
};

Progress.defaultProps = {
  width: '100%',
  bg: 'light',
  type: 'negative'
};
var _default = Progress;
exports["default"] = _default;